var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "a",
    _vm._g(
      {
        staticClass: "search-result-company",
        class: _vm.classes,
        attrs: {
          "data-bot": _vm.context
            ? "search-result__company--" + _vm.context
            : "search-result__company",
          href: _vm.link
        },
        on: {
          mouseenter: _vm.handleMouseEnter,
          mouseleave: function($event) {
            _vm.isHovered = false
          }
        }
      },
      _vm.$listeners
    ),
    [
      _c("CompassObject", {
        attrs: { size: "extra-small", type: "object", object: "company" }
      }),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "search-result-company__content" },
        [
          _c(
            "div",
            { staticClass: "search-result-company__title" },
            [
              _c("h5", {
                staticClass:
                  "search-result-company__name typographies-paragraph-medium-bold",
                domProps: { innerHTML: _vm._s(_vm.name) }
              }),
              _vm._v(" "),
              _c(
                "TagThird",
                { attrs: { type: _vm.type, size: "extra-small" } },
                [
                  _vm._v(
                    "\n                " +
                      _vm._s(_vm.typeLabel) +
                      "\n            "
                  )
                ]
              ),
              _vm._v(" "),
              _vm.corpid
                ? _c(
                    "div",
                    {
                      staticClass:
                        "search-result-company__corp-id typographies-paragraph-small-semibold"
                    },
                    [
                      _vm._v(
                        "\n                " +
                          _vm._s(_vm.getCorpId) +
                          "\n            "
                      )
                    ]
                  )
                : _vm._e()
            ],
            1
          ),
          _vm._v(" "),
          _vm.address
            ? _c("p", {
                staticClass:
                  "search-result-company__address typographies-paragraph-medium-regular",
                domProps: { innerHTML: _vm._s(_vm.address) }
              })
            : _vm._e(),
          _vm._v(" "),
          _vm._l(_vm.getHighlightedExtraFields, function(extraField, index) {
            return _c(
              "div",
              {
                key: index,
                staticClass:
                  "typographies-paragraph-medium-regular search-result-company__extra-field"
              },
              [
                _c("span", [_vm._v(" " + _vm._s(extraField.label))]),
                _vm._v(" "),
                _c("span", {
                  domProps: { innerHTML: _vm._s(extraField.value) }
                })
              ]
            )
          })
        ],
        2
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }